import { ITokenInfo } from "~/types/global"
import { axiosInstance } from "~/utils/axios"

export async function getVoiceToken(
  tokenInfo: ITokenInfo
): Promise<{ data: { identity: string; token: string } }> {
  const prefix = tokenInfo.is_os_lite_user ? "os_lite/" : ""
  const url = `${prefix}tenants/${tokenInfo.tenant_id}/users/${tokenInfo.user_id}/voice/token`

  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export interface IVoiceNumber {
  phone_number: string
  country_code: string | null
  region_code: string | null
  status: string
  daily_cap: number
  day_count: number
  cooldown_until: string | null
}

export async function setCallHold(
  tokenInfo: ITokenInfo,
  callSid: string,
  hold: boolean
): Promise<{ data: { hold: boolean } }> {
  const prefix = tokenInfo.is_os_lite_user ? "os_lite/" : ""
  const url = `${prefix}tenants/${tokenInfo.tenant_id}/voice/calls/${callSid}/hold`

  return await axiosInstance({
    method: "POST",
    url,
    data: { hold },
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getVoiceNumbers(
  tokenInfo: ITokenInfo
): Promise<{ data: { numbers: IVoiceNumber[] } }> {
  const prefix = tokenInfo.is_os_lite_user ? "os_lite/" : ""
  const url = `${prefix}tenants/${tokenInfo.tenant_id}/voice/numbers`

  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}
